import {
  IAnalyticsScratchpadArgument,
  IAnalyticsEventScratchpad,
} from './types';
import { getScratchpadEventProperties } from './utils';

export const scratchpadCreated = (
  scratchpadArgs: IAnalyticsScratchpadArgument,
): IAnalyticsEventScratchpad => ({
  eventName: 'Scratchpad Created',
  ...getScratchpadEventProperties(scratchpadArgs),
});

export const scratchpadDeleted = (
  scratchpadArgs: IAnalyticsScratchpadArgument,
): IAnalyticsEventScratchpad => ({
  eventName: 'Scratchpad Deleted',
  ...getScratchpadEventProperties(scratchpadArgs),
});

export const scratchpadVisited = (
  scratchpadArgs: IAnalyticsScratchpadArgument,
): IAnalyticsEventScratchpad => ({
  eventName: 'Scratchpad Visited',
  ...getScratchpadEventProperties(scratchpadArgs),
});

export const scratchpadUpdated = (
  scratchpadArgs: IAnalyticsScratchpadArgument,
): IAnalyticsEventScratchpad => ({
  eventName: 'Scratchpad Updated',
  ...getScratchpadEventProperties(scratchpadArgs),
});

export const scratchpadUserRefreshed = (
  scratchpadArgs: IAnalyticsScratchpadArgument,
): IAnalyticsEventScratchpad => ({
  eventName: 'Scratchpad User Refreshed',
  ...getScratchpadEventProperties(scratchpadArgs),
});

export const scratchpadShared = (
  scratchpadArgs: IAnalyticsScratchpadArgument,
): IAnalyticsEventScratchpad => ({
  eventName: 'Scratchpad Shared',
  ...getScratchpadEventProperties(scratchpadArgs),
});
